import React, { useState, useRef, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import TopBar from "../../topbar/TopBar.js";
import { useNavigate, useLocation } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../../assets/svg/nav-prev.svg";
import { ReactComponent as TickIcon } from "../../../assets/svg/tick.svg";

import "./courier-create.css";
import SearchWithAPI from "../../common/searchbox/searchbox.js";
import { gateInfoApi, getCheckList, getEnabledFieldApi, getGateListApi, getLocation, getMobileNumberBasedVisitor, getResponsiblePersonApi, sendOTPApi, verifyOTPApi } from "../../visitor/visitor-api.js";
import { createCourierApi } from "../courier-api.js";
import moment from "moment";
import { ReactComponent as CameraProofIcon } from "../../../assets/svg/camera1.svg";
import { ReactComponent as CameraIcon } from "../../../assets/svg/camera.svg";
import { ReactComponent as UploadIcon } from "../../../assets/svg/upload_btn.svg";
import { ReactComponent as UploadImg } from "../../../assets/svg/upload_img.svg";
import { ReactComponent as ItemImg } from "../../../assets/svg/item_img.svg";
import { ReactComponent as GuestImg } from "../../../assets/svg/guests.svg";
import { ReactComponent as AddItem } from "../../../assets/svg/add_item.svg";
import { ReactComponent as PhoneIcon } from "../../../assets/svg/call.svg";
import { ReactComponent as ClockIcon } from "../../../assets/svg/clock 2.svg";
import SearchWithFreeTextAPI from "../../common/searchbox/searchbox-free-text.js";
import camera from "../../../assets/svg/camera.svg";
import { ReactComponent as SlotCloseIcon } from "../../../assets/svg/close-1.svg";
import { ReactComponent as ItemNameIcon } from "../../../assets/svg/itemname.svg";
import { ReactComponent as QuantityIcon } from "../../../assets/svg/Quantity.svg";
import { ReactComponent as DescriptionIcon } from "../../../assets/svg/Description.svg";
import { ReactComponent as MoreIcon } from "../../../assets/svg/more.svg";
import ProfileImage from "../../../assets/png/customer-icon.png";
import { FaCheck, FaTimes } from "react-icons/fa";
import {
  Toast,
  ToastContainer,
} from "react-bootstrap";
import DOMPurify from 'dompurify';
import CheckListFailedAdminModal from "../../modal-dialog/checklist-failed-admin-modal.js";
import CheckListFailedModal from "../../modal-dialog/checklist-failed-modal.js";
import PoweredBy from "../../common/poweredBy.jsx";

export const CourierCreate = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { visitorId, } = location.state || {};
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [enabledFields, setEnabledFields] = useState([]);
  const [mandatoryFields, setMandatoryFields] = useState([]);
  const [gateOption, setGateOption] = useState(null);
  const [responsiblePerson, setResponsiblePerson] = useState("");
  const [loginPerson, setLoginPerson] = useState({});
  const [isProofMandatory, setIsProofMandatory] = useState(false);
  const [isChecklistMandatory, setIsChecklistMandatory] = useState(false);
  const [isOtpMandatory, setIsOtpMandatory] = useState(false);
  const [countryCode, setCountryCode] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [otp, setOTP] = useState("");
  const [otpRef, setOTPRef] = useState("");
  const [isOTPSend, setIsOTPSend] = useState(false);
  const [isOTPVerified, setIsOTPVerified] = useState(false);
  const [loadingOTP, setLoadingOTP] = useState(false);
  const [visitorName, setVisitorName] = useState("");
  const [meetingType, setMeetingType] = useState("Direct");
  const [scheduleDate, setScheduleDate] = useState("");
  const [scheduleTime, setScheduleTime] = useState("");
  const [organization, setOrganization] = useState(null);
  const [purposeVisitOption, setPurposeVisitOption] = useState(null);
  const [locationOption, setLocationOption] = useState(null);
  const [email, setEmail] = useState("");
  const [checkList, setCheckList] = useState([]);
  const [errorCheckList, setErrorCheckList] = useState([]);
  const [isGuestEnable, setIsGuestEnable] = useState(false);
  const [departmentOption, setDepartmentOption] = useState(null);
  const [whomReceivedOption, setWhomReceivedOption] = useState(null);
  const [companyContactNumber, setCompanyContactNumber] = useState(null);
  const [itemInsideParcel, setItemInsideParcel] = useState("");
  const [fromAddress, setFromAddress] = useState("");
  const [toAddress, setToAddress] = useState("");
  const [meetingPerson, setMeetingPerson] = useState("");
  const [proofType, setProofType] = useState("");
  const [proofNumber, setProofNumber] = useState("");
  const [vehicleTypeOption, setVehicleTypeOption] = useState(null);
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [selectedTab, setSelectedTab] = useState("Items");
  const [itemData, setItemData] = useState(null);
  const [itemList, setItemList] = useState([]);
  const [guestList, setGuestList] = useState([]);
  const [alertItemIndex, setAlertItemIndex] = useState(null);
  const [isValidateCheckList, setValidateCheckList] = useState(true);

  const [checkListStatus, setCheckListStatus] = useState("pending");
  const [scheduleDateTime, setScheduleDateTime] = useState(null);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [showAddItemModal, setAddItemModal] = useState(false);
  const [showAddGuestModal, setAddGuestModal] = useState(false);
  const [showChecklistFailedModal, setChecklistFailedModal] = useState(false);
  const [showChecklistFailedAdminModal, setChecklistFailedAdminModal] = useState(false);
  const [validations, setValidations] = useState({
    "gate_id": "",
    "person_name": "",
    "in_time": "",
    "organization": "",
    "country_code": "",
    "mobile_number": "",
    "company_name": "",
    "company_contactnumber": "",
    "receiver_id": "",
    "location_id": "",
    "department_id": "",
    "items": "",
    "from_address": "",
    "to_address": "",
    'checklists': "",
    "validate_check_list": "",
    "check_list_status": "",
  });

  useEffect(() => {
    getGateList()
    /*  getEnabledField() */
  }, []);
  const isFieldEnabled = (field) => {
    return enabledFields.some(item => item === field);
  }
  const isFieldMandatory = (field) => {
    return mandatoryFields.some(item => item === field);
  }
  const getGateList = async () => {
    try {
      const response = await getGateListApi();
      if (response.status === 200 && response.data.success === true) {
        if (response.data.suggestionlist.length > 0) {
          handleGateDropdownChange(response.data.suggestionlist[0]);
        }
      }

    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const handleGateDropdownChange = (option) => {
    console.log(option)
    setGateOption(option);
    getLocationData(option.value)
    getGateInfo(option.value)
    getResponsiblePerson(option.value)
  };
  const handleMobileNumberDropdownChange = (option) => {
    setMobileNumber(option.value)
    getMobileNumberBasedVisitorData(option.value)
  };
  const handleMobileNumberOnChange = (term) => {
    const cleaned = (term || "").replace(/\D/g, "").slice(0, 15);
    setMobileNumber(cleaned);
    if (cleaned && cleaned.length > 0 && cleaned.length < 6) {
      setValidations((prev) => ({
        ...prev,
        mobile_number: "Mobile number must be between 6 and 15 digits",
      }));
    } else {
      setValidations((prev) => ({
        ...prev,
        mobile_number: "",
      }));
    }
  };
  const handleOrganizationDropdownChange = (option) => {
    console.log(option)
    setOrganization(option.value)
  };
  const handleOrganizationOnChange = (term) => {
    setOrganization(term)
  };
  const handlePurposeVisitDropdownChange = (option) => {
    console.log(option)
    setPurposeVisitOption(option)
  };
  const handleDepartmentDropdownChange = (option) => {
    console.log(option)
    setDepartmentOption(option)
  };
  const handleWhomReceivedDropdownChange = (option) => {
    console.log(option)
    setWhomReceivedOption(option)
  };

  const handleVehicleTypeDropdownChange = (option) => {
    console.log(option)
    setVehicleTypeOption(option)
  };

  const getMobileNumberBasedVisitorData = async (mobileNumber) => {

    try {
      const response = await getMobileNumberBasedVisitor(mobileNumber, 'Courier');
      if (response.success === true && response.message !== "MobileNumber Not Available !!") {
        const visitorData = response.data;
        setGateOption({ 'value': visitorData.gate_id ?? '', 'label': visitorData.gate ?? 'Select' })
        setVisitorName(visitorData.person_name ?? '')
        setOrganization(visitorData.company_name ?? '')
        setLocationOption({ 'value': visitorData.location_id ?? '', 'label': visitorData.location ?? 'Select' })
        setDepartmentOption({ 'value': visitorData.department_id ?? '', 'label': visitorData.department ?? 'Select' })
        setCompanyContactNumber(visitorData.company_contactnumber ?? '')
        getCheckListData(visitorData.location_id)

      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getLocationData = async (gateId) => {
    try {
      const response = await getLocation(gateId);
      if (response.status === true) {
        setLocationOption({ 'value': response.details.location_id, 'label': response.details.location });
        getCheckListData(response.details.location_id)
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getEnabledField = async () => {
    const data = { "type": "Visitor" }
    try {
      const response = await getEnabledFieldApi(data);
      if (response.success === true) {
        setEnabledFields(response?.enabled_fields ?? {})
        setMandatoryFields(response?.mandatory_fields ?? {})
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getGateInfo = async (gateId) => {
    const data = { "gate_id": gateId }
    try {
      const response = await gateInfoApi(data);
      if (response.success === true) {
        setIsProofMandatory(response?.gate_details?.proof_mandatory ?? false)
        setIsChecklistMandatory(response?.gate_details?.checklist_mandatory ?? false)
        setIsOtpMandatory(response?.gate_details?.otp_mandatory ?? false)
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getResponsiblePerson = async (gateId) => {
    try {
      const response = await getResponsiblePersonApi(gateId);
      if (response.success === true) {
        setResponsiblePerson(response.responsible_person);
        setLoginPerson(response?.employee ?? '')
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getCheckListData = async (locationId) => {

    try {
      const response = await getCheckList(locationId, 'Courier');
      if (response.success === true) {
        setCheckList(response.suggestionlist);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const sendOTPData = async (mobilenumber) => {
    setIsOTPSend(true)
    setLoadingOTP(true)
    setOTPRef("")
    try {
      const response = await sendOTPApi({ 'template_name': 'Gate-Visitor-OTP', "mobilenumber": mobilenumber });
      if (response.success === true) {
        setOTPRef(response.otp_id);
        setSnackbarMessage(response.message);
        setSnackbarStatus(response.success);
        handleSnackbarShow();
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setLoadingOTP(false)
    }
  };

  const verifyOTP = async () => {
    setIsOTPVerified(false)
    const data = {
      "location_id": locationOption.value,
      "otp_id": otpRef,
      "received_otp": otp,
    }
    try {
      const response = await verifyOTPApi(data);
      if (response.success === true) {
        setIsOTPVerified(true)
        setSnackbarMessage(response.message);
        setSnackbarStatus(response.success);
        handleSnackbarShow();
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const submitCourier = async (isCheckListValidate, checkListStatus) => {
    try {

      const tempItemsParcel = [];
      if (itemInsideParcel !== "") {
        tempItemsParcel.push(itemInsideParcel);
      }
      const dataBeforeSanitize = {
        "gate_id": gateOption != null ? gateOption.value : "",
        "person_name": visitorName,
        "in_time": moment(new Date()).format("YYYY-MM-DD hh:mm"),
        "organization": "",
        "country_code": countryCode === "" ? "91" : countryCode,
        "mobile_number": mobileNumber,
        "company_name": organization ?? "",
        "company_contactnumber": companyContactNumber,
        "receiver_id": whomReceivedOption != null ? whomReceivedOption.value : "",
        "location_id": locationOption != null ? locationOption.value : "",
        "department_id": departmentOption != null ? departmentOption.value : "",
        "items": tempItemsParcel,
        "from_address": fromAddress,
        "to_address": toAddress,
        'checklists': meetingType === 'Schedule'
          ? null
          : checkList.map((check) => ({
            "id": DOMPurify.sanitize(check.id),
            "value": DOMPurify.sanitize(check.inputvalue?.toString())
          })),
        "validate_check_list": isCheckListValidate,
        "check_list_status": checkListStatus,

      };
      const dataAfterSanitize = {};
      Object.entries(dataBeforeSanitize).forEach(([key, value]) => {
        if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === "checklists") {
          dataAfterSanitize[key] = value;
        } else {
          dataAfterSanitize[key] = DOMPurify.sanitize(value);
        }
      });
      const response = await createCourierApi(dataAfterSanitize);
      if (response.status === 200) {
        if (response.data.status === true || response.data.success === true) {
          setSnackbarMessage(response.data.message);
          setSnackbarStatus(true);
          handleSnackbarShow();
          navigate(-1);
        } else {
          if (response.data.error) {
            const validationTemp = {
              "gate_id": "",
              "person_name": "",
              "in_time": "",
              "organization": "",
              "country_code": "",
              "mobile_number": "",
              "company_name": "",
              "company_contactnumber": "",
              "receiver_id": "",
              "location_id": "",
              "department_id": "",
              "items": "",
              "from_address": "",
              "to_address": "",
              'checklists': "",
              "validate_check_list": "",
              "check_list_status": "",
            };
            Object.entries(response.data.error).forEach(([key, value]) => {
              validationTemp[key] = value?.[0] || "";
            });
            setValidations(validationTemp);
          } else {
            setSnackbarMessage(response.data.message || "Failed to create courier");
            setSnackbarStatus(false);
            handleSnackbarShow();
          }
        }
      }
      if (response.status === 402) {
        setErrorCheckList(response.data.error)
      }
      if (response.status === 400) {
        const validationTemp = {
          "gate_id": "",
          "person_name": "",
          "in_time": "",
          "organization": "",
          "country_code": "",
          "mobile_number": "",
          "company_name": "",
          "company_contactnumber": "",
          "receiver_id": "",
          "location_id": "",
          "department_id": "",
          "items": "",
          "from_address": "",
          "to_address": "",
          'checklists': "",
          "validate_check_list": "",
          "check_list_status": "",
        };
        Object.entries(response.data.error).forEach(([key, value]) => {
          validationTemp[key] = value?.[0] || "";
        });
        setValidations(validationTemp);
      }

    } catch (error) {
      console.error("Submit visitor failed:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const canvasRef = useRef(null);
  const [image, setImage] = useState(null);
  useEffect(() => {

    if (isCameraOpen === true) {
      setImage(null);
      getVideo();
    }

  }, [isCameraOpen])
  const getVideo = () => {
    navigator.mediaDevices.enumerateDevices().then((devices) => {
      console.log("Devices start:", devices);
    });

    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then(stream => {
        streamRef.current = stream;
        console.log(videoRef.current)
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
      })
      .catch(err => {
        console.error("Error accessing camera:", err);
      });
  };
  const stopVideo = () => {
    console.log(streamRef.current);

    if (streamRef.current) {
      console.log(streamRef.current.getTracks());
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;

    }
    console.log(videoRef.current);
    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
    setIsCameraOpen(false);
    forceStopCamera()
  };
  const forceStopCamera = async () => {
    const devices = await navigator.mediaDevices.enumerateDevices();

    if (devices.some((device) => device.kind === "videoinput")) {
      const tempStream = await navigator.mediaDevices.getUserMedia({ video: true });

      tempStream.getTracks().forEach((track) => track.stop()); // Force stop

      console.log("Force-stopped extra video streams.");
    }
  };
  const captureImage = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    // Set canvas size to match video
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    // Draw the video frame on the canvas
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    // Convert canvas to image URL
    const imageUrl = canvas.toDataURL("image/png");
    setImage(imageUrl);
  };

  const [selectedImageList, setSelectedImageList] = useState([]);
  const [base64FileList, setBase64FileList] = useState([]);
  const [urlImageList, setUrlImageList] = useState([]);
  const [removedImageList, setRemovedImageList] = useState([]);

  const fileInputRef = useRef(null);
  const handleFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    } else {
      console.error("File input is not initialized.");
    }
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result;
        const tempBase64FileList = [...base64FileList];
        tempBase64FileList.push(base64String);
        setBase64FileList(tempBase64FileList)

      };
      reader.readAsDataURL(file);
      const tempImageList = [...selectedImageList];
      tempImageList.push(URL.createObjectURL(file));
      setSelectedImageList(tempImageList);
    } else {
      alert("Please select a valid image file.");
    }
  };
  const onSaveItem = (itemData) => {
    setAddItemModal(false);
    const tempItem = [...itemList];
    if (itemData.index === null) {
      tempItem.push(itemData.item)
    } else {
      tempItem[itemData.index] = itemData.item;
    }
    setItemList(tempItem)
  }

  const onSaveGuest = (itemData) => {
    setAddGuestModal(false);
    const tempGuest = [...guestList];
    if (itemData.index === null) {
      tempGuest.push(itemData.guest)
    } else {
      tempGuest[itemData.index] = itemData.guest;
    }
    setGuestList(tempGuest)
  }

  const alertRef = useRef(null);
  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleClickOutside = (event) => {
    if (alertRef.current && !alertRef.current.contains(event.target)) {
      setAlertItemIndex(null); // Close the alert
    }
  };
  const onProceedCheckList = () => {
    setChecklistFailedModal(false);
    setChecklistFailedAdminModal(false);
    setValidateCheckList(false)
    submitCourier(false, 'pending')

  }
  const onApprovedCheckList = () => {
    setValidateCheckList(false)
    setChecklistFailedAdminModal(false);
    setCheckListStatus('approve')
    submitCourier(false, 'approve')
  }
  useEffect(() => {
    if (errorCheckList.length > 0) {
      console.log(loginPerson)
      console.log(responsiblePerson)
      if (responsiblePerson === loginPerson.id) {
        setChecklistFailedAdminModal(true)
      } else {
        setChecklistFailedModal(true)
      }

    }
  }, [errorCheckList])
  return (
    <Container fluid className="main-container">
      {showChecklistFailedModal && <CheckListFailedModal checkList={errorCheckList} loginPerson={loginPerson} onSave={onProceedCheckList} onCancel={() => { setChecklistFailedModal(false); }} />}
      {showChecklistFailedAdminModal && <CheckListFailedAdminModal checkList={errorCheckList} visitorName={visitorName} organization={organization ?? ""} visitorPicture={image ?? ''} isSaveEnable={true} onSave={onProceedCheckList} isApprovedEnable={true} onApproved={onApprovedCheckList} onCancel={() => { setChecklistFailedAdminModal(false); }} />}
      <div style={{ width: "100vw" }}>
        <TopBar currentName="courier" />

        <Row sm={12} className="main-row">
          <Col className="mx-2 " sm={12} style={{ padding: "16px" }}>
            <Row sm={12}>
              <Col sm={6} md={9}>
                <div className="style-justify-start">
                  <div
                    onClick={() => {
                      navigate(-1);
                    }}
                    style={{
                      cursor: "pointer",
                      width: "40px",
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <BackIcon />
                  </div>
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "700",
                      color: "#21272C",
                    }}
                  >
                    Add courier
                  </span>
                </div>
              </Col>
              <Col sm={6} md={3}>
                <div className="style-justify-end" style={{ gap: "8px" }}>
                  <div
                    className="cancel_btn"
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "400",
                        color: "#21272C",
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                  <div
                    className="success_btn"
                    style={{
                      width: "100px",          // 👈 set fixed width
                      height: "40px",          // 👈 optional but recommended
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: isSubmitting ? "not-allowed" : "pointer",
                    }}
                    onClick={() => {
                      if (isSubmitting) return;
                      setIsSubmitting(true);
                      submitCourier(true, "pending");
                    }}
                  >
                    {isSubmitting ? (
                      <span
                        className="spinner-border spinner-border-sm text-light"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight: "400",
                          color: "#FFFFFF",
                        }}
                      >
                        Submit
                      </span>
                    )}
                  </div>
                  {/* <div
                    className="success_btn"
                    onClick={() => {
                      submitCourier(true, 'pending')
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "400",
                        color: "#FFFFFF",
                      }}
                    >
                      Submit
                    </div>
                  </div> */}
                </div>
              </Col>
            </Row>
            <Row className="mt-3 ">
              <Col xs={12} sm={12} lg={6}>
                <div className="card-view">
                  <div className="style-justify-start">
                    <div className="gate-title" style={{ width: '120px' }}>Entry gate<span style={{ color: '#FF4444' }}>*</span> : </div>
                    <div className="w-100">
                      <SearchWithAPI onDropdownChange={handleGateDropdownChange} apiUrl={apiUrl + "gate/autosuggestion"} params={{}} placeholder={"Gate"} selectedOption={gateOption} />
                      <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.gate_id}</span>
                    </div>
                  </div>
                </div>
                <div className="card-view mt-3">
                  <div className="card-title">Verify visitor mobile number</div>
                  <Row style={{ display: "flex" }}>
                    {/* {isFieldEnabled("Mobile number") && ( */}<Col sm={12} lg={6} className="mt-3">
                      <div className="field-title">Mobile number<span style={{ color: '#FF4444' }}>*</span></div>
                      <div
                        className="style-justify-start-start mt-1"
                        style={{ gap: "8px" }}
                      >
                        <div style={{ width: "100%" }}>
                          {/* <input
                            style={{ width: "100%" }}
                            type="text"
                            placeholder="Mobile number "
                            className="input-field"
                            value={mobileNumber}
                            onChange={(event) => {
                              const value = event.target.value.replace(
                                /\D/g,
                                ""
                              ); // Remove non-numeric characters
                              setMobileNumber(value);
                            }}
                          /> */}
                          <SearchWithFreeTextAPI numberOnly={true} onDropdownChange={handleMobileNumberDropdownChange} onChangeSearch={handleMobileNumberOnChange} apiUrl={apiUrl + `mobile_autocomplete`} params={{ type: "Courier" }} searchLimit={6} placeholder={"Select"} selectedValue={mobileNumber} />

                        </div>

                      </div>
                      <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.mobile_number}</span>
                    </Col>{/* )}  */}


                    <Col sm={12} lg={6} className="mt-3">
                      <div className="field-title">Person Name<span style={{ color: '#FF4444' }}>*</span></div>
                      <div className="mt-1">
                        <div>
                          <input
                            type="text"
                            placeholder="Enter here"
                            className="input-field w-100"
                            value={visitorName}
                            onChange={(event) => {
                              setVisitorName(event.target.value);
                            }}
                          />
                        </div>
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.person_name}</span>
                      </div>
                    </Col>


                    {/* {isFieldEnabled("Organization") && ( */}<Col sm={12} lg={6} className="mt-3">
                      <div className="field-title">Company Name<span style={{ color: '#FF4444' }}>*</span></div>
                      <div className="mt-1">
                        <div>
                          {/* <SearchWithAPI onDropdownChange={handleOrganizationDropdownChange} apiUrl={apiUrl+"courier/company"} params={{}} placeholder={"Organization"} selectedOption={organization}/> */}
                          <SearchWithFreeTextAPI onDropdownChange={handleOrganizationDropdownChange} onChangeSearch={handleOrganizationOnChange} apiUrl={apiUrl + `courier/company`} params={{}} searchLimit={0} placeholder={"Organization"} selectedValue={organization} />
                          <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.company_name}</span>
                        </div>
                      </div>
                    </Col>{/* )} */}

                    {/* {isFieldEnabled("Location") && ( */}<Col sm={12} lg={6} className="mt-3">
                      <div className="field-title">Location{isFieldMandatory("Location") && (<span style={{ color: '#FF4444' }}>*</span>)}</div>
                      <div className="mt-1">
                        <div>
                          <input
                            type="text"
                            placeholder=""
                            className="input-field w-100"
                            value={locationOption?.label ?? ''} readOnly="true"
                          />
                        </div>
                      </div>
                      <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.location_id}</span>
                    </Col>{/* )} */}
                    {/* {isFieldEnabled("Department") && ( */}<Col sm={12} lg={6} className="mt-3">
                      <div className="field-title">Department{isFieldMandatory("Department") && (<span style={{ color: '#FF4444' }}>*</span>)}</div>
                      <div className="mt-1">
                        <div>
                          <SearchWithAPI onDropdownChange={handleDepartmentDropdownChange} apiUrl={adminApiUrl + "get_department"} params={{}} placeholder={"Select"} selectedOption={departmentOption} />
                          <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.department_id}</span>
                        </div>
                      </div>
                    </Col>{/* )} */}
                    <Col sm={12} lg={6} className="mt-3">
                      <div className="field-title">Company contact number</div>
                      <div className="mt-1">
                        <div>
                          <input
                            type="text"
                            placeholder="Enter here"
                            className="input-field w-100"
                            maxLength={15}
                            value={companyContactNumber}
                            onChange={(event) => {
                              const value = event.target.value.replace(
                                /\D/g,
                                ""
                              ).slice(0, 15); // Remove non-numeric characters and max 15 digits
                              setCompanyContactNumber(value);
                              if (value && value.length > 0 && value.length < 6) {
                                setValidations((prev) => ({
                                  ...prev,
                                  company_contactnumber: "Contact number must be between 6 and 15 digits",
                                }));
                              } else {
                                setValidations((prev) => ({
                                  ...prev,
                                  company_contactnumber: "",
                                }));
                              }
                            }}
                          />
                        </div>
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.company_contactnumber}</span>
                      </div>
                    </Col>
                    {/* {isFieldEnabled("Meeting person") && ( */}<Col sm={12} lg={6} className="mt-3">
                      <div className="field-title">Whom received<span style={{ color: '#FF4444' }}>*</span>{/* {isFieldMandatory("Meeting person") && (<span style={{color:'#FF4444'}}>*</span>)} */}</div>
                      <div className="mt-1">
                        <div>
                          <SearchWithAPI onDropdownChange={handleWhomReceivedDropdownChange} apiUrl={adminApiUrl + "get_employee"} params={{}} placeholder={"Select"} selectedOption={whomReceivedOption} />
                          <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.receiver_id}</span>
                        </div>
                      </div>
                    </Col>{/* )} */}

                    <Col sm={12} className="mt-3">
                      <div className="field-title">Item inside the parcel<span style={{ color: '#FF4444' }}>*</span></div>
                      <div className="mt-1">
                        <div>
                          <input
                            type="text"
                            placeholder="Enter here"
                            className="input-field w-100"
                            value={itemInsideParcel}
                            onChange={(event) => {
                              setItemInsideParcel(event.target.value);
                            }}
                          />
                        </div>
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.items}</span>
                      </div>
                    </Col>
                  </Row>
                </div>



              </Col>
              <Col xs={12} sm={12} lg={6}>

                <div className="card-view">
                  <div className="style-justify-between">
                    <div className="card-title">Address details</div>
                    {meetingType === 'Direct' && (<div className="today-date-time style-justify-center">
                      <ClockIcon />
                      <div className="px-2">{moment(new Date()).format("DD MMM YYYY [at] hh:mm A")}</div>
                    </div>)}
                  </div>

                  <Row style={{ display: "flex" }}>
                    <Col sm={12} className="mt-3">
                      <div className="field-title">From address<span style={{ color: '#FF4444' }}>*</span></div>
                      <div className="mt-1">
                        <div>
                          <input
                            type="text"
                            placeholder="Enter here"
                            className="input-field w-100"
                            value={fromAddress}
                            onChange={(event) => {
                              setFromAddress(event.target.value);
                            }}
                          />
                        </div>
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.from_address}</span>
                      </div>
                    </Col>
                    <Col sm={12} className="mt-3">
                      <div className="field-title">To address<span style={{ color: '#FF4444' }}>*</span></div>
                      <div className="mt-1">
                        <div>
                          <input
                            type="text"
                            placeholder="Enter here"
                            className="input-field w-100"
                            value={toAddress}
                            onChange={(event) => {
                              setToAddress(event.target.value);
                            }}
                          />
                        </div>
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.to_address}</span>
                      </div>
                    </Col>
                  </Row>
                </div>

                <div className="card-view mt-2">
                  <div className="card-title">Check list {isChecklistMandatory && (<span style={{ color: '#FF4444' }}>*</span>)}</div>
                  <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.check_list_status}</span>
                  <div className="mt-3" style={{ gap: '8px' }}>
                    {checkList.map((check, index) => {
                      if (check.inputvalue == null) {
                        check["inputvalue"] = "";
                      }
                      const checklistError = validations[`checklists.${index}.value`];
                      const cleanError = checklistError
                        ? checklistError.replace(/the checklists\.\d+\.value field/i, `"${check.checkname}"`).replace(/the checklists\.\d+\.value/i, `"${check.checkname}"`)
                        : "";
                      return (
                        <div key={"checklist" + index} className="mb-2">
                          <div className="check-list style-justify-between">
                            <div>{check.checkname}</div>
                            {check.creteria !== "Boolean" && (
                              <div>
                                <input
                                  style={{ width: "100px" }}
                                  type="text"
                                  placeholder={check.checkname}
                                  className="input-field"
                                  value={check.inputvalue}
                                  onChange={(event) => {
                                    const value = event.target.value.replace(
                                      /\D/g,
                                      ""
                                    );
                                    const tempChecklist = [...checkList];
                                    tempChecklist[index]["inputvalue"] = value;
                                    setCheckList(tempChecklist);
                                    setValidations(prev => ({
                                      ...prev,
                                      [`checklists.${index}.value`]: ""
                                    }));
                                  }}
                                />
                              </div>
                            )}

                            {check.creteria === "Boolean" && (
                              <div className="style-justify-start" style={{ gap: '8px' }}>
                                <div
                                  className={`checklist-bool style-justify-start ${check.inputvalue ? "active-bool-btn" : ""}`}
                                  onClick={() => {
                                    const tempChecklist = [...checkList];
                                    tempChecklist[index]["inputvalue"] = true;
                                    setCheckList(tempChecklist);
                                    setValidations(prev => ({
                                      ...prev,
                                      [`checklists.${index}.value`]: ""
                                    }));
                                  }}
                                >
                                  <FaCheck style={{ color: check.inputvalue ? 'white' : '#172B4D' }} />
                                  <div style={{ paddingLeft: '8px' }}> Yes</div>
                                </div>
                                <div
                                  className={`checklist-bool style-justify-start ${check.inputvalue === false ? "in-active-bool-btn" : ""}`}
                                  onClick={() => {
                                    const tempChecklist = [...checkList];
                                    tempChecklist[index]["inputvalue"] = false;
                                    setCheckList(tempChecklist);
                                    setValidations(prev => ({
                                      ...prev,
                                      [`checklists.${index}.value`]: ""
                                    }));
                                  }}
                                >
                                  <FaTimes style={{ color: check.inputvalue === false ? 'white' : '#172B4D' }} />
                                  <div style={{ paddingLeft: '8px' }}> No</div>
                                </div>
                              </div>
                            )}
                          </div>
                          {cleanError && (
                            <span style={{ display: "flex", alignItems: "center", justifyContent: "end", fontSize: "11px", fontWeight: 400, color: "#FF4444", marginTop: "2px" }}>
                              {cleanError}
                            </span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </Col>
            </Row>
          </Col>

        </Row>

      </div>

      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>
  );
};
